import { supabase } from '../lib/supabase';

export const subscriptionService = {
  async getPlans() {
    try {
      const { data, error } = await supabase?.from('subscription_plans')?.select('*')?.eq('is_active', true)?.order('tier_level', { ascending: true });

      if (error) throw error;
      return { plans: data || [], error: null };
    } catch (error) {
      console.error('Error fetching plans:', error);
      return { plans: [], error: error?.message };
    }
  },

  async getUserSubscription(userId) {
    try {
      const { data, error } = await supabase?.from('user_subscriptions')?.select(`
          *,
          plan:subscription_plans(*)
        `)?.eq('user_id', userId)?.eq('status', 'active')?.single();

      if (error && error?.code !== 'PGRST116') throw error;
      return { subscription: data, error: null };
    } catch (error) {
      console.error('Error fetching subscription:', error);
      return { subscription: null, error: error?.message };
    }
  },

  async createCheckoutSession(planId, userId, userEmail) {
    try {
      const { data, error } = await supabase?.functions?.invoke('create-checkout-session', {
        body: { planId, userId, userEmail },
      });

      if (error) throw error;
      return { sessionId: data?.sessionId, url: data?.url, error: null };
    } catch (error) {
      console.error('Error creating checkout session:', error);
      return { sessionId: null, url: null, error: error?.message };
    }
  },

  async cancelSubscription(subscriptionId) {
    try {
      const { error } = await supabase?.from('user_subscriptions')?.update({ cancel_at_period_end: true })?.eq('id', subscriptionId);

      if (error) throw error;
      return { success: true, error: null };
    } catch (error) {
      console.error('Error canceling subscription:', error);
      return { success: false, error: error?.message };
    }
  },

  hasFeatureAccess(subscription, feature) {
    if (!subscription) return false;
    
    const tierLevel = subscription?.plan?.tier_level || 0;
    
    // Feature access based on tier
    const featureMap = {
      basic_products: 1, // Starter+
      ai_descriptions: 1, // Starter+
      simple_simulator: 1, // Starter+
      realtime_pricing: 2, // Profissional+
      smart_kits: 2, // Profissional+
      strategic_suggestions: 2, // Profissional+
      unlimited_products: 2, // Profissional+
      opportunity_insights: 2, // Profissional+
      advanced_reports: 3, // Scale only
      multi_user: 3, // Scale only
      priority_support: 3, // Scale only
    };

    return tierLevel >= (featureMap?.[feature] || 999);
  },
};